import { LogicService } from '../../../core/canvas-logic/base/logic-service';
import {
    InterfaceFactoryOptions,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';

import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';
import { ILogic } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-logic/base/logic.interface';
import {
    ComponentTypes,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/component-types';
import { TextEditorLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/logic/component-logic/text-editor-logic';
export class NoteEditLogicService extends LogicService {
    public constructor() {
        super();
    }

    public createComponentLogic(factoryOptions: InterfaceFactoryOptions, component: IBaseComponent): ILogic | null {
        const componentType = component.getComponentType();
        switch (componentType) {
            case ComponentTypes.TEXTEDITOR:
                return new TextEditorLogic(factoryOptions, component);
        }
        return null;
    }
}
